/** 1 以上の安全な整数へ正規化する。不正値は逐次実行へフォールバックする。 */
export function normalizeConcurrency(value) {
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : 1;
}

/**
 * 入力順を保ったまま、指定した同時実行数以下で非同期処理する。
 * shouldStart が false になった後は未開始の項目を投入しない。
 */
export async function mapWithConcurrency(items, mapper, {
    concurrency = 1,
    signal = null,
    shouldStart = () => true,
} = {}) {
    const list = Array.from(items ?? []);
    if (list.length === 0) return [];
    if (typeof mapper !== 'function') throw new TypeError('mapper は関数で指定してください');

    const results = new Array(list.length);
    let nextIndex = 0;
    const worker = async () => {
        while (shouldStart()) {
            if (nextIndex >= list.length) return;
            signal?.throwIfAborted();
            const index = nextIndex;
            nextIndex += 1;
            results[index] = await mapper(list[index], index);
        }
    };

    const workerCount = Math.min(normalizeConcurrency(concurrency), list.length);
    // 1 worker の中断だけで先に return すると、ほかの処理が呼び出し元の終了後も書き込みを続ける。
    // 全 worker が安全な区切りへ到達するまで待ち、最初の例外をその後に伝播する。
    const settled = await Promise.allSettled(Array.from({ length: workerCount }, () => worker()));
    const rejected = settled.find((result) => result.status === 'rejected');
    if (rejected) throw rejected.reason;
    return results;
}
